<style lang="stylus">
        .albumDetail-box
            padding-bottom 7px
            padding-top 16px
            .albumDetail-box__title
                font-size 18px
                padding-bottom 20px
                .albumDetail-box__title-community
                    color #000
                    cursor pointer
                    span
                        color #000
                    &:hover
                        color #017fff
                .albumDetail-box__title-album
                    color #606266
            .albumDetail-box__banner
                position relative
                .banner-bg
                    width 100%
                .banner-btn
                    position absolute
                    right 10%
                    top 50%
                    transform translateY(-50%)
                    font-size 16px
                    padding: 7px 20px 7px 20px;
                    border: 1px solid #FFFFFF;
                    border-radius: 36px;
                    color #fff
                    cursor pointer
                    z-index 1
                    min-width 98px
                    @media screen and (max-width: 1350px)
                        font-size 14px
                    @media screen and (max-width: 900px)
                        display none
                .banner-btn:hover
                    background-color #fff
                    color #333
    .albumDetail-backicon
        width 20px
        height 12px
        padding 0 4px
        svg
            width 12px
            height 12px
            transform rotate(180deg)
    .dark-theme_albumdetail
        .albumDetail-box__title
            .albumDetail-box__title-community
                color #fff
            .albumDetail-box__title-album
                color #fff
            .albumDetail-backicon
                fill #fff
                stroke #fff
</style>

<template>
    <div class="albumDetail-box container" :class="{ 'dark-theme_albumdetail': isPCDarkMode == 2 }">
        <div class="albumDetail-box__title">
            <span class="albumDetail-box__title-community" @click="showTemplateCommunity">{{ albumBoxTitle.community }}</span>
            <span class="albumDetail-box__title-community" v-show="showAllAlbumBreadcrumb" @click="showAlbumList">
                <span class="albumDetail-backicon">
                    <iconSymbol name="preview-back" />
                </span>
                {{ "全部专辑" }}
            </span>
            <span class="albumDetail-box__title-album">
                <span class="albumDetail-backicon">
                    <iconSymbol name="preview-back" />
                </span>
                {{ albumDetail.title }}
            </span>
        </div>
        <div ref="albumDetail-box__banner" class="albumDetail-box__banner">
            <img class="banner-bg" :src="`${window['GLOBAL'].PUBLIC_OSS_HOST + albumDetail.cover_url}banner_big.png`" alt="" />
            <div class="banner-btn" v-if="!isOldVersion" @click="showPublishBox(true)">我要发布</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "albumDetail",
        data() {
            return {
                albumBoxTitle: {
                    community: "模板社区",
                    album: " > 全部专辑",
                },
                albumDetail: {},
            };
        },
        computed: {
            isOldVersion() {
                if (!this.pcVersion) {
                    return false;
                }
                let arr = this.pcVersion.split(".");
                if (arr[1] < 1 || (arr[1] == 1 && arr[2] == 0)) {
                    return true;
                } else {
                    return false;
                }
            },
            pcVersion() {
                return this.$store.state.pcVersion;
            },
            activeAlbumID() {
                return this.$store.state.tplCenter.activeAlbumID;
            },
            showAllAlbumBreadcrumb() {
                return this.$store.state.tplCenter.showAllAlbumBreadcrumb;
            },
        },
        methods: {
            showTemplateCommunity: function () {
                this.$bus.$emit("initWorkClass");
                this.$bus.$emit("updateFilter", {
                    album: null,
                    page: 1,
                    offset: 0,
                });
                this.$store.commit("toTplCenter", {
                    name: "activeAlbumID",
                    data: -1,
                });
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "default",
                });
            },
            initBanner: function () {
                // this.$refs['albumDetail-box__banner'].style.cssText = "background-image:" + "url(" + window["GLOBAL"].PUBLIC_OSS_HOST + this.albumDetail.cover_url + 'banner.png'+")"
            },
            showPublishBox(v) {
                if (!this.$validateLogin()) return;
                this.$store.commit("setState", {
                    type: "showPublish",
                    data: v,
                });
            },
            showAlbumList() {
                this.$store.commit("toTplCenter", {
                    name: "albumPageStatus",
                    data: "list",
                });
            },
        },
        mounted: function () {
            this.initBanner();
        },
        created: function () {
            this.albumDetail = this.$store.state.tplCenter.albumList.find((item) => {
                return item.id == this.activeAlbumID;
            });
        },
        beforeDestroy() {
            this.$store.commit("toTplCenter", {
                name: "showAllAlbumBreadcrumb",
                data: false,
            });
        },
    };
</script>
